import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RequestHeaders } from "../../common/header-logo/request-header.component";
import RequestHeaderTab from "./request-header-tab.component";
import { CreateRequest } from "./create-request/create-request.component";
import { requestLogActions } from "./../../../store/external/request-reducer/request-log.reducer";
import { createRequestActions } from "./../../../store/external/request-reducer/create-request.reducer";
import { REQUEST_SUB_LINKS as RequestTable, RAISE_REQUEST_LINKS as RaiseRequestLink } from "../../../constants/external-constants";
import "./request-page.component.css";
import Filter from "../../common/filter/filter.component";
import ButtonIcon from "../../button";
import { CustomColumns } from "../../common/modal-popover/custom-columns";
import { validateAccessModule } from "../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../utils/rbac-constants.utils";

class RequestPage extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)
        this.state = {
            displaySearch: false,
            exportAlertMsg: "Please confirm that the harvesting of data and it's usage has been approved by the client.",
        }
    }

    componentWillMount() {
        const { fetchRequestLogItems, fetchCreateRequestItems, activeRequestTable} = this.props;

        fetchCreateRequestItems();
        fetchRequestLogItems(0, activeRequestTable);
    }

    searchAction = async (e) => {
        let searchValue = e.target.value;
        this.props.setRequestSearchValue(searchValue);
        if (e.key === 'Enter') {
            await this.props.fetchRequestLogItems();
            e.preventDefault();
        } 
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractRequsetLogs();
        }
    };
    applyFilter = (isApply) => {
        const { fetchRequestLogItems, applyOrderRequestFilter, activeRequestTable } = this.props;
        applyOrderRequestFilter(isApply);
        fetchRequestLogItems(0, activeRequestTable);
    }

    DisplaySearhBox() {
        const { displaySearch } = this.props;
        const updatedDisplaySearch = !displaySearch;
        this.props.isDisplaySearch(updatedDisplaySearch);
        this.setState({ displaySearch: updatedDisplaySearch });
    }

    openRequestModal = (id, type) => {
        const { history, setRequestType, activeRequestTable } = this.props;
        setRequestType(id, type);

        switch (activeRequestTable) {
            case RaiseRequestLink.allRequest.id:
                history.push(RaiseRequestLink.allRequest.link + id); break;
            case RaiseRequestLink.orderRequest.id:
                history.push(RaiseRequestLink.orderRequest.link + id); break;
            case RaiseRequestLink.quotationRequest.id:
                history.push(RaiseRequestLink.quotationRequest.link + id); break;
            case RaiseRequestLink.approvalRequest.id:
                history.push(RaiseRequestLink.approvalRequest.link + id); break;
            case RaiseRequestLink.coverageRequest.id:
                history.push(RaiseRequestLink.coverageRequest.link + id); break;
            default:
        }
        
    };

    resetUrl = () => {
        this.props.history.goBack();
    }

    render() {
        const { history, setRequestType, saveOrderRequestCustomCols, addOrderRequestFilter, removeOrderRequestFilter, orderRequestData } = this.props;
        const { requestTypes, isRequestTypesLoaded } = this.props.createRequest;
        const { Selected, Available, Default } = this.props.orderRequestData.Columns;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.RequestsAllRequestsR, ACCESS_MODULE.RequestsMyRequestsR, ACCESS_MODULE.RequestsForApprovalR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.RequestsAllRequestsRE, ACCESS_MODULE.RequestsMyRequestsRE, ACCESS_MODULE.RequestsForApprovalRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.RequestsAllRequestsRW, ACCESS_MODULE.RequestsMyRequestsRW, ACCESS_MODULE.RequestsForApprovalRW])

        return (
            <div>
                <RequestHeaders headerTitle="my_request_form" />
                <div className="request-table data-table fit-width">
                    <Filter data={orderRequestData.TableFilterData} addAction={addOrderRequestFilter}
                    removeAction={removeOrderRequestFilter} applyAction={this.applyFilter} customClassName="request-filter" extractAction={(e)=> this.onClickExtract(e)} />
                    <div className="horizontal-separator"></div>
                    <div className="request-header-container-button">
                        {(isReadOnly ? false : (isReadAndExtractOnly ? false : (isReadAndWrite ? true : false))) &&
                            <CreateRequest requestTypes={requestTypes}
                                isLoaded={isRequestTypesLoaded}
                                closeAction={this.resetUrl}
                                openRequestModal={this.openRequestModal}
                                setRequestType={setRequestType} />
                        }
                        
                        <div className="container-filter-button">
                            <ButtonIcon onClick={this.DisplaySearhBox.bind(this)} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search" />
                            <CustomColumns firstList={Available} secondList={Selected} defaultList={Default} saveAction={saveOrderRequestCustomCols} />
                            {(isReadOnly ? false : (isReadAndExtractOnly ? true : (isReadAndWrite ? true : false))) &&
                                <ButtonIcon onClick={(e) => this.onClickExtract(e)} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Extract List" />
                            }
                        </div>
                    </div>
                    <RequestHeaderTab searchAction={this.searchAction} displaySearch={this.state.displaySearch} />
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestLog, createRequest } = state;
        return {
            ...requestLog
            , createRequest
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, createRequestActions),
            dispatch
        )
)(RequestPage);
